import { render, staticRenderFns } from "./RxAddress.vue?vue&type=template&id=6336362c&scoped=true"
import script from "./RxAddress.vue?vue&type=script&lang=js"
export * from "./RxAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336362c",
  null
  
)

export default component.exports